import React from 'react'
// import SearchSection from './Rcomponents/select'
import Description from './Rcomponents/description'
import Rooms from './Rcomponents/room'
import './style.css'
import SearchSection from '../SearchSection/index'

const RoomSingleSection = ({ data }) => {
   return (
      <div className="room-single-page">
         {/* <SearchSection data={data} /> */}
         <div style={{ marginTop: "100px", marginBottom: "50px" }}> <SearchSection data={data} /> </div>
         <Rooms data={data} />
         <Description data={data} />
      </div>
   )
}

export default RoomSingleSection;